'use strict';
const angular = require('angular');

/*@ngInject*/
export function PropertyService($resource) {
  return $resource('/api/properties/:id', {
    id: '@_id'
  },{
    getByContact: {
      method: 'GET',
      url: "/api/properties/contact/:contactId",
      isArray: true
    },
    getByCommunity: {
      method: 'GET',
      url: "/api/properties/community/:communityId",
      isArray: true
    },
    getContacts: {
      method: 'GET',
      url: "/api/properties/:id/contacts",
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/properties/:id/attachments"
    },
    getPropertiesVoting: {
      method: 'GET',
      url: "/api/properties/voting",
      isArray: true
    },
    getPropertiesVotingByUser: {
      method: 'GET',
      url: "/api/properties/voting/:contactId",
      isArray: true
    },
    getPropertiesByVoter: {
      method: 'GET',
      url: "/api/properties/voter/:contactId",
      isArray: true
    },
    querySuite: {
      method: 'GET',
      url: "/api/properties/suite",
      isArray: true
    },
    queryDT: {
      method: 'POST',
      url: '/api/properties/datatables'
    },
  });
}


export default angular.module('conduu.PropertyService', [])
  .factory('PropertyService', PropertyService)
  .name;



// WEBPACK FOOTER //
// ./client/components/property/property.service.js